// extracted by mini-css-extract-plugin
export default {"submit-form-button__container":"styles_submit-form-button__container__ouBYO","submit-form-input__container":"styles_submit-form-input__container__drlQl"};